<script>
export default {
    name: 'ForgotPassword',
    components: {}
}
</script>

<template>
    <b-container>
        <b-row>
            <b-col lg="6" offset-lg="3" class="mt-5">
                <b-card header="Page Not Found">
                    Sorry, the page you are looking for cannot be found.
                    <template #footer>
                        <b-button size="sm" variant="secondary" :to="{ name: 'dashboard' }">Go Back Home</b-button>
                    </template>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>